import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { PackageTypesDataService, PackageTypesColumnsService } from '../../../services';
import { PackageType, PackageTypesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-package-type-details',
  templateUrl: './package-type-details.component.html',
  styleUrls: ['./package-type-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PackageTypeDetailsComponent implements OnInit, OnDestroy {

  public packageType: PackageType = {};
  public packageTypes: PackageType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private packageTypesDataService: PackageTypesDataService,
    private packageTypesColumnsService: PackageTypesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Package Type - Details');
        this.getPackageType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.packageType !== 'undefined') {
      this.packageType = this.dynamicDialogConfig.data.packageType;
    }
    this.columns = this.packageTypesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getPackageType(id: number): void {
    this.isLoading = true;
    this.packageTypesDataService.getPackageType(id).subscribe((response: PackageType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.packageType = response;
      }
    });
  }

  list() {
    this.router.navigate(['/package-types']);
  }

  add() {
    this.router.navigate(['/package-types/add']);
  }

  edit() {
    this.router.navigate(['/package-types/edit/' + this.packageType.id]);
  }

}
@Component({
  selector: 'app-package-type-details',
  templateUrl: './package-type-details.component.html',
  styleUrls: ['./package-type-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPackageTypeDetailsComponent extends PackageTypeDetailsComponent {
}

